import { createContext } from "react";
import type { CallProviderProps } from "@/types/contexts/call";

export const CallContext = createContext<CallProviderProps | undefined>(undefined);
